import { atomWithReset } from 'jotai/utils';

import {
  Answer,
  DEFAULT_PAGE,
  DEFAULT_PER_PAGE,
  DeleteMedicationFollowupMessageModal,
  EventPageInfo,
  PatientDetailConfirmBreakaway,
  PatientDetailDialog,
  PatientDetailDialogMessage,
  PatientDetailDialogPatientComment,
  PatientDetailDialogPatientMobilePhone,
  PatientDetailDialogProfile,
  PatientDetailDialogTracingReport,
} from './types';

export const patientDetailDialogState = atomWithReset<PatientDetailDialog>({
  isOpen: false,
  patientId: null,
  type: 'message',
  eventId: null,
  recommendationPresetCode: null,
});

export const patientDetailDialogTracingReportState =
  atomWithReset<PatientDetailDialogTracingReport>({
    selectedSheetId: null,
  });

export const patientDetailDialogPatientCommentState =
  atomWithReset<PatientDetailDialogPatientComment>({
    selectedCommentId: null,
    isDeleteModalOpen: false,
  });

export const patientDetailDialogMessageState = atomWithReset<PatientDetailDialogMessage>({
  profile: null,
  selectedMessageId: null,
  draftMessageId: null,
  messageInfoStatus: 'new',
  messageInfoIsOpen: true,
});

export const eventPageInfoState = atomWithReset<EventPageInfo>({
  isResetEvent: false,
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PER_PAGE,
});

export const answerState = atomWithReset<Answer>({
  answer: null,
});

export const patientDetailDialogProfileState = atomWithReset<PatientDetailDialogProfile>({
  type: null,
});

export const patientDetailConfirmBreakawayState = atomWithReset<PatientDetailConfirmBreakaway>({
  isOpen: false,
  action: null,
});

export const deleteMedicationFollowupMessageModalState =
  atomWithReset<DeleteMedicationFollowupMessageModal>({
    isOpen: false,
    medicationFollowupMessageId: null,
  });

export const patientDetailDialogPatientMobilePhoneState =
  atomWithReset<PatientDetailDialogPatientMobilePhone>({
    isOpen: false,
  });
